import styled from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { transformSrcSetToCss } from '@yme/utils/styles';
export const TestRideCardStyled = styled.div `
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  margin-bottom: ${({ marginBottom }) => marginBottom && `${marginBottom}`};
  aspect-ratio: ${({ aspectRatio }) => aspectRatio && `${aspectRatio}`};

  width: 100%;

  ${({ srcSet, imageUrl }) => transformSrcSetToCss(srcSet, imageUrl)}
`;
export const LinkStyled = styled(Link) `
  width: 100%;
  text-decoration: none;
`;
